import * as React from "react";
import Button from "./../../Button";
import { Icon } from "antd";
import { test } from "./sample_response.js";
import { scaleLinear } from "d3-scale";
import _ from "lodash";
var m = require("react-simple-maps");
let { ComposableMap, ZoomableGroup, Geographies, Geography } = m;
import { ChoroplethLegend } from "./ChoroplethLegend";
import "./style.css";

/* Demo Scale */

interface IMetric {
  state: string | null;
}
export class Choropleth extends React.Component<any, any> {
  constructor() {
    super();
    this.state = {
      hoverGeo: null,
      zoom: 0.8,
      width: 1000,
      hover: false
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  updateDimensions = () => {
    const width = document.getElementById("mapContainer")
      ? document.getElementById("mapContainer").clientWidth
      : 0;
    this.setState({ width });
  };

  zoom = (zoomType: string) => {
    if (zoomType == "in") this.setState(prevState => ({ zoom: prevState.zoom + 0.5 }));
    else if (this.state.zoom > 1)
      this.setState(prevState => ({ zoom: prevState.zoom - 0.5 }));
  };

  colorScale = (min: number, max: number) => {
    return scaleLinear<string>()
      .domain([min ? min - 100 : 0, max + 100])
      .range(["#D6EFF4", "#009ABA"]);
  };

  render() {
    let mapConfig: any = {
      canada: {
        scale: 700,
        xOffset: 390,
        yOffset: 360,
        rotation: [-10, 0, 0]
      },
      usa: {
        scale: 1080,
        xOffset: 660,
        yOffset: 320
      }
    };

    let __this = this;
    let usaMapURL = this.state.zoom < 200 ? "us_topo.json" : "nielsentopo.json";
    let canadaMapURL = this.state.zoom < 200 ? "ca_topo.json" : "ca_fsas.json";
    let mapURL = this.props.country == "usa" ? usaMapURL : canadaMapURL;
    let strokeWidth = 0.15;
    let config = this.props.country
      ? mapConfig[this.props.country]
      : mapConfig["canada"];
    let colorScale = this.colorScale(this.props.min, this.props.max);
    let hoverValueShift = (this.props.max - this.props.min) / 5; //20% color shift for hover

    let regionName = "";
    if (this.state.hoverGeo)
      if (this.state.hoverGeo.properties.NAME)
        regionName = this.state.hoverGeo.properties.NAME;
      else regionName = this.state.hoverGeo.properties.CFSAUID;

    if (this.props.zeroData)
      return (
        <div className="null-text">
          <span className="analytics-null-text">
            There's no data available for the selected dropdowns.
            <br />
            Try changing the dropdowns to view data.
          </span>
        </div>
      );

    const nullStates = this.props.metricData.find(
      (m: IMetric) => m.state === null
    );
    const unknownData = !!nullStates
      ? nullStates[this.props.metric] - this.props.extraStates
      : 0;

    return (
      <div className="map-container" id="mapContainer">
        <div className="zoom-btn-container">
          <Button
            onClick={() => {
              this.zoom("in");
            }}
            icon="plus"
            type="primary"
          />
          <br />
          <Button
            icon="minus"
            type="primary"
            onClick={() => {
              this.zoom("out");
            }}
          />
        </div>
        <div className="mapLegend">
          <ChoroplethLegend
            min={this.props.min ? this.props.min - 100 : 0}
            max={this.props.max + 100}
          />
        </div>

        <div className="legend-container" style={{ fontSize: 14 }}>
          <div style={{ display: regionName ? "block" : "none" }}>
            {regionName}
            <br />
            <span style={{ fontWeight: "bold", fontSize: 14 }}>
              {_.startCase(this.props.metric.replace("_", " "))}
            </span>
            &nbsp;
            {this.props.data[regionName]
              ? this.props.data[regionName].toLocaleString()
              : 0}
          </div>

          <div
            style={{ display: !regionName ? "block" : "none", fontSize: 14 }}
          >
            Unknown location
            <div>
              <span style={{ fontWeight: "bold", fontSize: 14 }}>
                {_.startCase(`${this.props.metric}`.replace("_", " "))}
              </span>{" "}
              {unknownData
                .toString()
                .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}
            </div>
          </div>
        </div>
        <ComposableMap
          projectionConfig={config}
          projection="times"
          width={this.state.width}
        >
          <ZoomableGroup zoom={this.state.zoom}>
            <Geographies geographyUrl={`${location.origin}/${mapURL}`}>
              {(geographies: any, projection: any) =>
                geographies.map(function (geography: any, i: any) {
                  let name = geography.properties["NAME"];
                  name = name ? name : geography.properties["CFSAUID"];
                  let val = __this.props.data[name];
                  let zeroColor = "rgb(212, 212, 212)";
                  return (
                    <Geography
                      key={`geography-${i}`}
                      geography={geography}
                      projection={projection}
                      onClick={(e: any) => {}}
                      onMouseEnter={(e: any) => {
                        __this.setState({ hoverGeo: e, hover: true });
                      }}
                      onMouseOut={() => {
                        __this.setState({ hover: false, hoverGeo: null });
                      }}
                      style={{
                        default: {
                          fill: val ? colorScale(val) : zeroColor,
                          stroke: "#fff",
                          strokeWidth: strokeWidth
                        },
                        hover: {
                          fill: val
                            ? colorScale(val + hoverValueShift)
                            : zeroColor,
                          stroke: "#fff",
                          strokeWidth: strokeWidth
                        },
                        pressed: {
                          fill: val
                            ? colorScale(val + hoverValueShift)
                            : zeroColor,
                          stroke: "#fff",
                          strokeWidth: strokeWidth
                        }
                      }}
                    />
                  );
                })
              }
            </Geographies>
          </ZoomableGroup>
        </ComposableMap>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/core/Chart/Choropleth/index.tsx